import React from 'react';
import Image from 'next/image';
import {useIsAuthPath} from "../../../shared/hooks/useAuth";
import {Box, Container, Divider, Typography} from "@mui/material";
import ContactUsSocial from "../../contact-us/components/ContactUsSocial";
import {useFindById} from "../../backoffice/configuration/contact-us-message-infos/contact.us.message.info.service";

export default function Footer() {

    const {data} = useFindById();
    const isAuthPath = useIsAuthPath();
    if (isAuthPath) return null;

    return (
        <Box sx={{
            minHeight: 400,
            position: "relative",
            background: theme => theme.palette.grey[800],
        }}>
            <Container maxWidth="xl" sx={{color: "white", py: 4}}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 3
                }}>
                    <Box sx={{flex: 1}}>
                        <Typography variant="h5">
                            Mali Tourisme - Bamako City Tour
                        </Typography>

                        <Typography sx={{fontSize: {md: 20, xs: 18}, mt: 1}}>
                            {data?.description}
                        </Typography>
                    </Box>

                    <Box sx={{flexShrink: 0}}>
                        <Image
                            src="/images/loga.png" // remplace par le bon chemin de ton logo
                            alt="Logo Loga"
                            width={140}
                            height={70}
                            style={{objectFit: "contain"}}
                        />
                    </Box>
                </Box>

                <Divider sx={{my: 3}}/>

                {data && <ContactUsSocial data={data} />}
            </Container>
        </Box>
    );
}
